// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M 14.4 4.35 C 14.1 3.09 13.16 2.07 11.93 1.68 C 11.57 1.56 11.19 1.5 10.79 1.5 H 9.65 C 9.18 1.5 8.8 1.88 8.8 2.35 V 7.77 C 8.8 8.4 9.31 8.91 9.94 8.91 H 13.36 C 13.99 8.91 14.5 8.4 14.5 7.77 V 5.21 C 14.5 4.91 14.47 4.62 14.4 4.35 Z',
  'M6.45 4.75C5.81 4.75 5.3 5.26 5.3 5.9V10.4C5.3 11.04 5.81 11.55 6.45 11.55H9.7C10.34 11.55 10.85 11.04 10.85 10.4',
  'M3.15 8C2.51 8 2 8.51 2 9.15V13.35C2 13.99 2.51 14.5 3.15 14.5H6.4C7.04 14.5 7.55 13.99 7.55 13.35',
];
